import React, { Component } from "react";
import { Empty, Spin, Select } from "antd";
import { LeftOutlined, RightOutlined, ReloadOutlined, CalendarOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, DatePickerItem, MensajeError } from "../../../../../Components/Items";
import PlaneacionPresupuestoPU from "./PlaneacionPresupuestoPU";
import { estiloBarraFiltros } from "./planeacion.utils";
import BotonReporteDiaProduccionPU from "./BotonReporteDiaProduccionPU";

const estiloNavegador = {
  display: "inline-flex",
  alignItems: "center",
  height: 32,
  border: "1px solid #d9d9d9",
  borderRadius: 8,
  background: "white",
  overflow: "hidden",
};
const estiloFlecha = { border: "none", boxShadow: "none", height: 30, width: 32, borderRadius: 0 };

moment.locale("es");

const REFRESCO_MS = 60 * 1000;

class PlaneacionProduccionPU extends Component {
  intervalo = null;
  state = {
    loading: false,
    grupos: [],
    presupuestosDisponibles: [],
    flujosDisponibles: [],
    presupuestoPUId: undefined,
    flujoId: undefined,
    ahora: null,
    modo: "dia",
    fecha: moment(),
  };

  componentDidMount() {
    this.consultar();
    this.intervalo = setInterval(() => this.consultar(true), REFRESCO_MS);
    document.addEventListener("visibilitychange", this.alCambiarVisibilidad);
  }

  componentWillUnmount() {
    clearInterval(this.intervalo);
    document.removeEventListener("visibilitychange", this.alCambiarVisibilidad);
  }

  alCambiarVisibilidad = () => {
    if (document.visibilityState === "visible") this.consultar(true);
  };

  rango = () => {
    if (this.state.modo === "todas") return { desde: null, hasta: null };
    const unidad = this.state.modo === "semana" ? "isoWeek" : "day";
    return { desde: this.state.fecha.clone().startOf(unidad), hasta: this.state.fecha.clone().endOf(unidad) };
  };

  consultar = (silencioso = false) => {
    const { desde, hasta } = this.rango();
    if (!silencioso) this.setState({ loading: true });
    axios
      .post(
        "ordenesDeProduccionPU/planeacionOrdenes",
        {
          empresaId: this.props.empresaId,
          desde: desde ? desde.toDate() : undefined,
          hasta: hasta ? hasta.toDate() : undefined,
          presupuestoPUId: this.state.presupuestoPUId,
          flujoId: this.state.flujoId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({
            grupos: res.data.grupos || [],
            presupuestosDisponibles: res.data.presupuestosDisponibles || [],
            flujosDisponibles: res.data.flujosDisponibles || [],
            ahora: res.data.ahora,
          });
        } else if (!silencioso) {
          MensajeError({ message: res.data.error || "No se pudo cargar la planeación" });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        if (!silencioso) MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  cambiarModo = (modo) => this.setState({ modo }, () => this.consultar());

  cambiarFecha = (fecha) => fecha && this.setState({ fecha: moment(fecha) }, () => this.consultar());

  moverRango = (paso) =>
    this.setState(
      (prev) => ({ fecha: prev.fecha.clone().add(paso, prev.modo === "semana" ? "week" : "day") }),
      () => this.consultar()
    );

  etiquetaRango = () => {
    const { desde, hasta } = this.rango();
    if (this.state.modo === "todas") return "Todas las órdenes activas";
    if (this.state.modo === "dia") return desde.format("dddd DD [de] MMMM");
    return `${desde.format("DD MMM")} - ${hasta.format("DD MMM YYYY")}`;
  };

  renderControles() {
    const esSemana = this.state.modo === "semana";
    return (
      <div style={estiloBarraFiltros}>
        <SegmentedItem
          options={[
            { label: "Día", value: "dia" },
            { label: "Semana", value: "semana" },
            { label: "Todas", value: "todas" },
          ]}
          value={this.state.modo}
          onChange={this.cambiarModo}
        />
        {this.state.modo !== "todas" && (
        <div style={estiloNavegador}>
          <ButtonItem type="text" style={estiloFlecha} icon={<LeftOutlined />} onClick={() => this.moverRango(-1)} />
          <DatePickerItem
            sinBorde
            value={this.state.fecha}
            picker={esSemana ? "week" : "date"}
            format={esSemana ? "[Semana] w · YYYY" : "DD/MM/YYYY"}
            allowClear={false}
            suffixIcon={<CalendarOutlined style={{ color: "#8c8c8c" }} />}
            onChange={this.cambiarFecha}
            style={{ width: esSemana ? 170 : 140, borderLeft: "1px solid #f0f0f0", borderRight: "1px solid #f0f0f0", height: 30 }}
          />
          <ButtonItem type="text" style={estiloFlecha} icon={<RightOutlined />} onClick={() => this.moverRango(1)} />
        </div>
        )}
        {this.state.modo !== "todas" && (
          <ButtonItem blanco botonAncho onClick={() => this.cambiarFecha(moment())}>
            Hoy
          </ButtonItem>
        )}
        <Select
          allowClear
          showSearch
          optionFilterProp="children"
          placeholder="Flujo"
          style={{ width: 200 }}
          value={this.state.flujoId}
          onChange={(flujoId) => this.setState({ flujoId }, () => this.consultar())}
        >
          {this.state.flujosDisponibles.map((flujo) => (
            <Select.Option key={flujo._id} value={flujo._id}>
              {flujo.nombre}
            </Select.Option>
          ))}
        </Select>
        <Select
          allowClear
          showSearch
          optionFilterProp="children"
          placeholder="Presupuesto"
          style={{ width: 220 }}
          value={this.state.presupuestoPUId}
          onChange={(presupuestoPUId) => this.setState({ presupuestoPUId }, () => this.consultar())}
        >
          {this.state.presupuestosDisponibles.map((presupuesto) => (
            <Select.Option key={presupuesto._id} value={presupuesto._id}>
              {presupuesto.nombre}
            </Select.Option>
          ))}
        </Select>
        <span style={{ color: "#1a3a4a", fontWeight: 600, textTransform: "capitalize" }}>{this.etiquetaRango()}</span>
        <div style={{ flex: 1 }} />
        <BotonReporteDiaProduccionPU
          desde={this.rango().desde ? this.rango().desde.toDate() : undefined}
          hasta={this.rango().hasta ? this.rango().hasta.toDate() : undefined}
          etiquetaRango={this.etiquetaRango()}
          presupuestoPUId={this.state.presupuestoPUId}
          flujoId={this.state.flujoId}
        />
        <ButtonItem botonAncho naranja icon={<ReloadOutlined />} onClick={() => this.consultar()}>
          Actualizar
        </ButtonItem>
      </div>
    );
  }

  render() {
    const { grupos, loading, ahora, presupuestoPUId } = this.state;
    const rango = this.rango();

    return (
      <Spin spinning={loading}>
        {this.renderControles()}
        {grupos.length === 0 ? (
          <div style={{ backgroundColor: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)" }}>
            <Empty description="No hay órdenes de producción activas para planear" />
          </div>
        ) : (
          grupos.map((grupo) => (
            <div
              key={grupo._id}
              style={{ backgroundColor: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)", marginBottom: 12 }}
            >
              <PlaneacionPresupuestoPU
                presupuesto={grupo}
                presupuestoFiltroId={presupuestoPUId}
                ahora={ahora}
                etiquetaRango={this.etiquetaRango()}
                rango={{ desde: rango.desde ? rango.desde.toDate() : undefined, hasta: rango.hasta ? rango.hasta.toDate() : undefined }}
                onVer={this.props.onVer}
                onVerEtapas={this.props.onVerEtapas}
                onRefrescar={() => this.consultar(true)}
                permisoMoverPiezas={this.props.permisoMoverPiezas}
                permisoEditar={this.props.permisoEditar}
              />
            </div>
          ))
        )}
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(PlaneacionProduccionPU);
